<template>
  <puzzle-board />
</template>

<script>
import PuzzleBoard from '@/components/Puzzle/PuzzleBoard';

export default {
  name: 'App',
  components: { PuzzleBoard },
};
</script>

<style lang="scss"></style>
